<template>
    <!-- Trigger slot lets parent supply its own button/link -->
    <slot name="trigger" :open="openModal" />
  
    <!-- Modal overlay & panel -->
    <transition name="fade">
      <div v-if="isOpen" class="fixed inset-0 z-50 flex items-center justify-center">
        <!-- Backdrop -->
        <div class="absolute inset-0 bg-black/60 backdrop-blur-sm" @click="closeModal"></div>
  
        <!-- Dialog -->
        <div
          role="dialog"
          aria-modal="true"
          class="relative w-full max-w-md rounded-2xl bg-white dark:bg-gray-800 p-6 shadow-xl"
        >
          <!-- Header -->
          <header class="mb-4 flex items-center gap-2">
            <slot name="icon">
              <!-- Default icon -->
              <svg class="h-6 w-6 text-blue-600" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" d="M13 16h-1v-4h-1m1-4h.01M12 19.25c4.556 0 6.75-3.694 6.75-7.25S16.556 4.75 12 4.75 5.25 8.444 5.25 12 7.444 19.25 12 19.25z" />
              </svg>
            </slot>
            <h2 class="text-xl font-semibold">
              <slot name="title">Are you absolutely sure?</slot>
            </h2>
          </header>
  
          <!-- Body -->
          <div class="mb-6 text-sm text-gray-600 dark:text-gray-300">
            <slot>
              This action cannot be undone. This will permanently delete your account and remove your data from our servers.
            </slot>
          </div>
  
          <!-- Footer -->
          <footer class="flex justify-end gap-3">
            <button
              type="button"
              class="rounded-lg bg-blue-600 px-4 py-2 text-white hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300"
              @click="continueModal"
            >
              Ok
            </button>
          </footer>
        </div>
      </div>
    </transition>
  </template>
  
  <script setup>
  import { ref, defineEmits, defineExpose } from 'vue'
  
  // tracks visibility
  const isOpen = ref(false)
  
  // emit events so parent can react
  const emit = defineEmits(['cancel', 'continue'])
  
  function openModal() {
    isOpen.value = true
  }
  
  function closeModal() {
    isOpen.value = false
    emit('cancel')
  }
  
  function continueModal() {
    isOpen.value = false
    emit('continue')
  }
  
  // expose all handlers for optional programmatic use (also silences ESLint no‑unused‑vars)
  defineExpose({ openModal, closeModal, continueModal })
  </script>
  
  <style scoped>
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.25s;
  }
  .fade-enter-from,
  .fade-leave-to {
    opacity: 0;
  }
  </style>
  